import * as Types from '../../../__generated__/schema';

import { PolicySummary } from './PolicySummary.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type PolicyDetails = Pick<Types.Policy, 'body' | 'suppressions'> & {
  reports: Array<Pick<Types.DetectionReportMapping, 'key' | 'values'>>;
  tests: Array<
    Pick<Types.DetectionTestDefinition, 'expectedResult' | 'name' | 'resource'> & {
      mocks?: Types.Maybe<
        Array<Pick<Types.DetectionTestMockDefinition, 'objectName' | 'returnValue'>>
      >;
      ruleOutputs?: Types.Maybe<
        Array<Pick<Types.CorrelationRuleTestCaseRuleOutputDefinition, 'id' | 'matches'>>
      >;
    }
  >;
} & PolicySummary;

export const PolicyDetails = gql`
  fragment PolicyDetails on Policy {
    ...PolicySummary
    body
    suppressions
    reports {
      key
      values
    }
    tests {
      expectedResult
      name
      resource
      mocks {
        objectName
        returnValue
      }
      ruleOutputs {
        id
        matches
      }
    }
  }
  ${PolicySummary}
`;
